import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";

import backArrow from "../../../assets/icons/backArrow.png";
import "./socialInfo.css";
import minus from "../../../assets/icons/minus.svg";
import plus from "../../../assets/icons/plus.svg";

import selectAncor from "../../../assets/icons/selectAncor.svg";
import selectAncorDe from "../../../assets/icons/selectAncorDe.svg";
import cancelSelect from "../../../assets/icons/cancelSelect.svg";
import icontwitter from "../../../assets/icons/icontwitter.svg";
import selectIcon from "../../../assets/icons/selectIcon.svg";
import unSelectIcon from "../../../assets/icons/unSelectIcon.svg";

import Select from "react-select";
import SuccessPage from "../successScreen/SuccessPage";
import SectionsHeader from "../../../genComponents/sectionsHeader/SectionsHeader";
import {
  DefaultHalfInputSocial,
  DefaultSubmitBtn,
} from "../../../genComponents/defaultInput/DefaultInput";
import { socialOptionData } from "../../../genComponents/locationOptionData/LocationOptionData";
import MiniCustomSelect from "../../../genComponents/miniCustomSelect/MiniCustomSelect";
import optionAssets from "../../../genComponents/locationOptionData/optionAssets";
import CustomSelected from "../../../genComponents/customSeletected/CustomSelected";
import { hideLoader, showLoader } from "../../../loader";
import { axiosCalls } from "../../../_api";
import { socialData } from "../../../genComponents/locationOptionData/LocationOptionData";
import { useId } from "react";
// import { uuid } from "uuidv4";
import uuid from "react-uuid";
import SuccessAlert from "../successAlert/SuccessAlert";
import FailureAlert from "../failureAlert/FailureAlert";
import AddNew from "../../../assets/icons/AddNew";
import TickIcon from "../../../assets/icons/TickIcon";
import DynamicCancel from "../../../genComponents/dynamicCancel/DynamicCancel";

const SocialInfo = () => {
  const unique_id = uuid();
  const [selectedOption, setSelectedOption] = useState([
    {
      account_type: "",
      icon_url: null,
      url: "",
      social_id: unique_id,
      isValid: true,
      inputStartsHttp: false,
    },
  ]);

  const [socialMediaText, setSocialMediaText] = useState([]);
  const [onSuccessSocialPage, setOnSuccessSocialPage] = useState(false);
  const [onErrorPage, setOnErrorPage] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const [preSelectSing, setPreSelectSing] = useState(0);
  const [selectIndex, setSelectIndex] = useState(0);
  const [saveBtnCheck, setSaveBtnCheck] = useState([
    {
      account_type: "",
      icon_url: null,
      url: "",
      social_id: unique_id,
      isValid: true,
      inputStartsHttp: false,
    },
  ]);

  const [defaultColor, setDefaultColor] = useState("");
  const [isValidt, setIsValidt] = useState(true);

  const [inputStartsHttpCheck, setInputStartsHttpCheck] = useState(false);

  // const payloadData = selectedOption.map(({account_type, icon_url, url, social_id, isValid})=>{

  //   if(account_type!=='whatsapp') {

  //     account_type, icon_url, social_id, isValid, url:"https://"+url
  //   } else { return account_type, icon_url, social_id, isValid, url:"https://wa.me"+url}
  // })

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const isButtonEnabled = () => {
    // Check if any of the objects in the array have non-empty 'text' property
    return selectedOption.some((item) => item.icon_url === null);
  };

  const payloadData = selectedOption.map(
    ({ account_type, icon_url, url, social_id, isValid }) => {
      if (account_type !== "whatsapp") {
        return {
          account_type,
          icon_url,
          social_id,
          isValid,
          url: "https://" + url,
        };
      } else {
        return {
          account_type,
          icon_url,
          social_id,
          isValid,
          url: "https://wa.me",
        };
      }
    }
  );

  useEffect(() => {
    // getProfileData();
    const initSocial = localStorage.getItem("Social");
    const parsedArr = JSON.parse(initSocial);
    setSelectedOption(parsedArr);
    setSocialMediaText(parsedArr);
    setSaveBtnCheck(parsedArr);
    console.log("selected option from local", parsedArr);

    setDefaultColor(localStorage.getItem("Default Theme"));
  }, []);

  useEffect(() => {
    defaultSelected();
  }, [isOpen]);

  const defaultSelected = () => {
    if (selectedOption[selectIndex].account_type === "Facebook") {
      setPreSelectSing(1);
    } else if (selectedOption[selectIndex].account_type === "Instagram") {
      setPreSelectSing(2);
    } else if (selectedOption[selectIndex].account_type === "LinkedIn") {
      setPreSelectSing(3);
    } else if (selectedOption[selectIndex].account_type === "Messenger") {
      setPreSelectSing(4);
    } else if (selectedOption[selectIndex].account_type === "Pinterest") {
      setPreSelectSing(5);
    } else if (selectedOption[selectIndex].account_type === "Snapchat") {
      setPreSelectSing(6);
    } else if (selectedOption[selectIndex].account_type === "Tumblr") {
      setPreSelectSing(7);
    } else if (selectedOption[selectIndex].account_type === "Twitter") {
      setPreSelectSing(8);
    } else if (selectedOption[selectIndex].account_type === "Whatsapp") {
      setPreSelectSing(9);
    } else if (selectedOption[selectIndex].account_type === "Youtube") {
      setPreSelectSing(10);
    } else if (selectedOption[selectIndex].account_type === "Tiktok") {
      setPreSelectSing(11);
    } else if (selectedOption[selectIndex].account_type === "Threads") {
      setPreSelectSing(12);
    } else if (selectedOption[selectIndex].account_type === "") {
      setPreSelectSing(0);
    }
  };

  const postProfileData = async (e) => {
    e.preventDefault();

    const data = {
      page: "social",
      social: selectedOption,
    };
    showLoader();
    const res = await axiosCalls(`admin/profile`, "POST", data);

    if (res) {
      hideLoader();
      console.log(res?.data);
      if (res?.er) {
        console.log(res?.data?.er);
        setOnErrorPage(true);
        setTimeout(() => {
          setOnErrorPage(false);
        }, 3000);
        return;
      }
      window.location.href = "/";

      setOnSuccessSocialPage(true);

      setTimeout(() => {
        setOnSuccessSocialPage(false);
        window.location.href = "/";
      }, 2000);
    }
  };

  const handleSocialMediaTextAdd = () => {
    const abc = [...socialMediaText, []];
    setSocialMediaText(abc);
  };

  const handleSocialMediaTextChange = (onChangeValue, i) => {
    const inputData = [...socialMediaText];
    inputData[i] = onChangeValue.target.value;
    setSocialMediaText(inputData);
  };

  const handleSocialMediaTextDelete = (i) => {
    const deletVal = [...socialMediaText];
    deletVal.splice(i, 1);
    setSocialMediaText(deletVal);
  };

  const handleSelectAdd = () => {
    setSelectedOption([
      ...selectedOption,

      {
        account_type: "",
        icon_url: null,
        url: "",
        social_id: unique_id,
        isValid: true,
        inputStartsHttp: false,
      },
    ]);

    setSaveBtnCheck([
      ...saveBtnCheck,

      {
        account_type: "",
        icon_url: null,
        url: "",
        social_id: unique_id,
        isValid: true,
        inputStartsHttp: false,
      },
    ]);

    // setSelectedOption(spreadSelect);
    console.log(selectedOption, "add new");
  };

  const handleSelectChange = (selectedItem, selectedItemImg, i) => {
    const inputData = [...selectedOption];
    inputData[i].account_type = selectedItem;
    inputData[i].icon_url = selectedItemImg;

    setSelectedOption(inputData);

    console.log(i, "index onChange");

    console.log(selectedOption);
  };

  // const handleSelectChange = (selectedItem, selectedItemImg, id) => {
  //   const newState = selectedOption.map((obj) => {
  //     // 👇️ if id equals 2 replace object
  //     if (obj.social_id === id) {
  //       return {
  //         social_id: id,
  //         account_type: selectedItem,
  //         icon_url: selectedItemImg,
  //       };
  //     }
  //     // 👇️ otherwise return the object as is
  //     return obj;
  //   });

  //   setSelectedOption(newState);

  //   console.log(id, "test id");
  //   console.log(selectedOption, "selecccc");
  // };

  const handletextChange = (mediaText, i) => {
    const prefixTextOne = "ftp://";
    // const prefixTextOne = "ftp://";
    const prefixText = "https://";
    const prefixTextOld = "http://";
    const whatsAppPrefix = "https://wa.me/";
    const whatsAppPrefixZero = "https://wa.me/0";
    const whatsAppPrefixOld = "http://wa.me/";
    const removeZero = "0";
    const inputData = [...selectedOption];
    const value = mediaText?.target?.value;
    inputData[i].url = mediaText?.target?.value;

    if (value?.toLowerCase()?.startsWith(whatsAppPrefixZero)) {
      inputData[i].url = value?.slice(15);
    } else if (value?.toLowerCase()?.startsWith(whatsAppPrefix)) {
      inputData[i].url = value?.slice(14);
    } else if (value?.toLowerCase()?.startsWith(whatsAppPrefixOld)) {
      inputData[i].url = value?.slice(13);
    } else if (value?.toLowerCase()?.startsWith(prefixTextOld)) {
      inputData[i].url = value?.slice(7);
    } else if (value?.toLowerCase()?.startsWith(prefixText)) {
      inputData[i].url = value?.slice(8);
    } else if (value?.toLowerCase()?.startsWith(prefixTextOne)) {
      inputData[i].url = value?.slice(6);
    } else if (value?.toLowerCase()?.startsWith(removeZero)) {
      if (inputData[i].account_type === "Whatsapp") {
        inputData[i].url = value?.slice(1);
      } else {
        inputData[i].url = value?.slice(0);
      }
    } else {
      inputData[i].url = value;
    }

    setSelectedOption(inputData);

    // if (inputData[i].url.startsWith("https://")) {
    //   //  setInputValue(value.substring("https://".length));

    //   const slicedInput = inputData[i].url.slice(8);

    //   setSelectedOption(inputData);

    //   // setSelectedOption(inputData);
    // } else {
    //   //  setInputValue(value);

    //   setSelectedOption(inputData);
    // }

    // if (
    //   inputData[i].url.startsWith(
    //     prefixText || whatsAppPrefix || prefixTextOld || whatsAppPrefixOld
    //   )
    // ) {
    //   inputData[i].inputStartsHttp = true;
    //   setInputStartsHttpCheck(true);
    // } else {
    //   inputData[i].inputStartsHttp = false;
    //   setInputStartsHttpCheck(false);
    // }
    // if (inputData[i].url.startsWith(prefixText || whatsAppPrefix)) {
    //   inputData[i].url = mediaText.target.value;
    // } else {
    //   // setInputValue(`${prefix}${value}`);

    //   // inputData[i].url = `${prefixText}${mediaText.target.value}`;

    //   inputData[i].url = `${
    //     selectedOption[i].account_type === "Whatsapp"
    //       ? whatsAppPrefix
    //       : prefixText
    //   }${mediaText.target.value}`;
    // }

    // setSelectedOption(inputData);

    // validateUrl(inputData[i].url, i);

    console.log(selectedOption);
  };

  const validateUrl = (value, index) => {
    // const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    const urlRegex = /^(http[s]?:\/\/|www\.|ftp:\/\/)/;

    // const urlRegex= ^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$

    if (urlRegex.test(value)) {
      const inputData = [...selectedOption];
      inputData[index].isValid = true;
      setSelectedOption(inputData);
      setIsValidt(true);
    } else {
      const inputData = [...selectedOption];
      inputData[index].isValid = false;
      setSelectedOption(inputData);
      setIsValidt(false);
    }
  };
  const handleSelectDelete = (i) => {
    const deleteSelectedVal = [...selectedOption];
    deleteSelectedVal?.splice(i, 1);
    setSelectedOption(deleteSelectedVal);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    //  saveToStorage();
    // setOnSuccessSocialPage(true);

    console.log("Data to API", selectedOption);

    // history.goBack();
  };

  const toggling = () => setIsOpen(!isOpen);
  const closeSelectToggle = () => {
    setIsOpen(false);
  };

  const handleChildClick = (event) => {
    event.stopPropagation();
  };

  const prefixText = "https://";
  const whatsAppPrefix = "https://wa.me/";

  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div className="totalResSocialBody">
      <div className="social-info-family">
        <SectionsHeader
          sectionName="Social media"
          handleGoBack={handleGoBack}
        />
        <form onSubmit={postProfileData}>
          <div>
            <div>
              {selectedOption?.map((selectedOpt, i) => {
                return (
                  <>
                    <div
                      style={{ marginBottom: "10px" }}
                      className="flex-inputs"
                    >
                      <div
                        onClick={() => {
                          toggling();
                          console.log("indicate index", i);
                          setSelectIndex(i);
                        }}
                        className="custom-selectBtnSocial"
                      >
                        {selectedOpt?.account_type === "" &&
                        selectedOpt?.icon_url === null ? (
                          <div className="custom-selectBtnTextSocial">
                            Select
                          </div>
                        ) : (
                          <div className="custom-selectedOptionGen">
                            <div className="customSelected-IconGen">
                              <img
                                src={selectedOpt?.icon_url}
                                alt="social_icon"
                              />
                            </div>
                            <div className="custom-selectBtnTextSocialSe">
                              {selectedOpt?.account_type}
                            </div>
                          </div>
                        )}

                        <div className="custom-selectAncorSocial">
                          <img src={selectAncorDe} alt="select-icnSocial" />
                        </div>
                      </div>

                      <div
                        style={{ marginBottom: "10px" }}
                        className="social-remove-section"
                      >
                        <div className="prefix_genSocial">
                          {selectedOpt?.account_type === "Whatsapp"
                            ? whatsAppPrefix
                            : prefixText}
                        </div>
                        <DefaultHalfInputSocial
                          type="text"
                          // value={`${
                          //   selectedOpt.account_type === "Whatsapp"
                          //     ? whatsAppPrefix
                          //     : prefixText
                          // }  ${selectedOpt?.url}`}
                          value={selectedOpt?.url}
                          name="socialAccount"
                          onChange={(e) => {
                            handletextChange(e, i);
                            console.log("text id", i);
                          }}
                          placeholder=" "
                          // spanText="Type or paste Link"
                          required={true}
                          socialsSelect={selectedOpt?.account_type}
                        />
                        {/* {selectedOption.length > 1 && ( */}
                        <div className="remove-social-icon ">
                          <img
                            src={minus}
                            alt="remove"
                            onClick={() => {
                              handleSelectDelete(i);
                              // handleSelectDeleteBtn(i);
                              // handleSocialMediaTextDelete(i);
                              console.log("handling delete id", i);
                            }}
                          />
                        </div>
                        {/* )} */}
                      </div>

                      {isOpen && (
                        <div
                          className="select-modal-bodySocial"
                          onClick={closeSelectToggle}
                        >
                          <div
                            className="select-modalBody-contSocial"
                            onClick={handleChildClick}
                          >
                            <div className="select-modalHeaderSocial">
                              <div className="select-modalHeader-textSocial">
                                Select Social
                              </div>
                              <div
                                onClick={closeSelectToggle}
                                className="select-modalHeader-canBtnSocial"
                              >
                                <DynamicCancel
                                  defaultTheme={defaultColor}
                                  // onClick={handleChildClick}
                                />
                              </div>
                            </div>
                            {/* {socialOptionData.map((socialData, index) => {
                            return (
                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    socialData?.account_type,
                                    socialData?.icon_url,
                                    i
                                  );

                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(index);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing, "preSelect");
                                  console.log(i, "index");
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={socialData?.icon_url} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      {socialData?.account_type}
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === index ? (
                                                
                                   <TickIcon
                          fill={
                            defaultColor === "" ? `#36A6A4` : `${defaultColor}`
                          }
                        />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })} */}

                            <div>
                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "Facebook",
                                    optionAssets.fbfacebook,
                                    selectIndex
                                  );

                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(1);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  console.log("handling", i);

                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={optionAssets.fbfacebook} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      Facebook
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 1 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "Instagram",
                                    optionAssets.iconinstagram,
                                    selectIndex
                                  );
                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(2);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  console.log("handling two", i);
                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={optionAssets.iconinstagram} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      Instagram
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 2 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "LinkedIn",
                                    optionAssets.iconlinkedin,
                                    selectIndex
                                  );
                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(3);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={optionAssets.iconlinkedin} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      LinkedIn
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 3 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "Messenger",
                                    optionAssets.iconmessenger,
                                    selectIndex
                                  );
                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(4);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={optionAssets.iconmessenger} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      Messenger
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 4 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "Pinterest",
                                    optionAssets.iconpinterest,
                                    selectIndex
                                  );
                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(5);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={optionAssets.iconpinterest} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      Pinterest
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 5 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "Snapchat",
                                    optionAssets.iconsnapchat,
                                    selectIndex
                                  );
                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(6);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={optionAssets.iconsnapchat} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      Snapchat
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 6 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "Tumblr",
                                    optionAssets.icontumblr,
                                    selectIndex
                                  );
                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(7);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={optionAssets.icontumblr} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      Tumblr
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 7 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "Twitter",
                                    optionAssets.new_twitter_logo,
                                    selectIndex
                                  );
                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(8);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img
                                        src={optionAssets.new_twitter_logo}
                                      />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      Twitter
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 8 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "Whatsapp",
                                    optionAssets.iconwhatsapp,
                                    selectIndex
                                  );
                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(9);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={optionAssets.iconwhatsapp} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      Whatsapp
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 9 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "Youtube",
                                    optionAssets.youtubeIcon,
                                    selectIndex
                                  );
                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(10);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={optionAssets.youtubeIcon} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      Youtube
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 10 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "Tiktok",
                                    optionAssets.tiktokIcon,
                                    selectIndex
                                  );
                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(11);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={optionAssets.tiktokIcon} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      Tiktok
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 11 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div
                                onClick={() => {
                                  handleSelectChange(
                                    "Threads",
                                    optionAssets.threads,
                                    selectIndex
                                  );
                                  // setSelectedOptionImg(
                                  //   singleOptionData?.socialHandleIcon
                                  // );
                                  setPreSelectSing(12);
                                  // console.log(selectedOption);
                                  console.log(preSelectSing);
                                  closeSelectToggle();
                                }}
                              >
                                <div className="select-modal-optionSocial">
                                  <div className="socialSelectIcon-famm">
                                    <div className="socialSelect-Iconn">
                                      <img src={optionAssets.threads} />
                                    </div>
                                    <div className="select-modal-optionTextSocial">
                                      Threads
                                    </div>
                                  </div>
                                  <div className="select-modal-optionIconSocial">
                                    {preSelectSing === 12 ? (
                                      <TickIcon
                                        fill={
                                          defaultColor === ""
                                            ? `#36A6A4`
                                            : `${defaultColor}`
                                        }
                                      />
                                    ) : (
                                      <img src={unSelectIcon} alt="unselect" />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div style={{ marginBottom: "100px" }}></div>
                            {/* <div
                            className="select-doneBtnSocial"
                            onClick={closeSelectToggle}
                          >
                            Done
                          </div> */}
                          </div>
                        </div>
                      )}
                    </div>
                    {selectedOpt.isValid === false ? (
                      <p className="url_validSocial">
                        Please enter a valid URL, prefix must start with either
                        www. or http:// or https:// or ftp://
                      </p>
                    ) : null}
                    {selectedOpt.inputStartsHttp ? (
                      <p className="url_validSocial">
                        Please remove prefix that starts with either http:// or
                        https:// or https://wa.me/
                      </p>
                    ) : null}
                  </>
                );
              })}
            </div>
            <div>
              {/* {selectedOption.map((data, i) => {
                return (
                  <div
                    style={{ marginBottom: "10px" }}
                    className="social-remove-section"
                  >
                    <DefaultHalfInputSocial
                      type="url"
                      value={data?.url}
                      name="socialAccount"
                      onChange={(e) => {
                        handletextChange(e, i);
                        console.log("text id", i);
                      }}
                      placeholder=" "
                      spanText="Type or paste Link"
                    />
                    {selectedOption.length > 1 && (
                      <div className="remove-social-icon ">
                        <img
                          src={minus}
                          alt="remove"
                          onClick={() => {
                            handleSelectDelete(i);
                            // handleSocialMediaTextDelete(i);
                            console.log("handling delete id", i);
                          }}
                        />
                      </div>
                    )}
                  </div>
                );
              })} */}
            </div>
          </div>

          {selectedOption.length < 10 && (
            <div className="add-social-family">
              <div
                onClick={() => {
                  handleSelectAdd();
                  // handleSocialMediaTextAdd();
                }}
                className="add-social-cont"
                style={{
                  color: defaultColor === "" ? `#36A6A4` : `${defaultColor}`,
                }}
              >
                <AddNew
                  fill={defaultColor === "" ? `#36A6A4` : `${defaultColor}`}
                />
                Add new
              </div>
            </div>
          )}

          <div
            style={{
              display: "flex",
              alignItem: "center",
              justifyContent: "center",

              width: "85%",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <DefaultSubmitBtn
              onClick={() => {
                postProfileData();
                // console.log(selectedOption, "kkkkkkk");
              }}
              valueText="Save"
              disabled={saveBtnCheck?.length < 1 || isButtonEnabled() === true}
              defaultColor={defaultColor}
            />
          </div>
        </form>

        {/* <button onClick={() => handleAdd()}>Add</button>
        {val.map((data, index) => {
          return (
            <div>
              <div
                onClick={() => {
                  handleChange("Apple", index);
                }}
              >
                Apple
              </div>

              <button onClick={() => handleDelete(index)}>X</button>
            </div>
          );
        })} */}
        {onSuccessSocialPage && (
          // <SuccessPage notifyText="Contact Information Saved" />

          <SuccessAlert alertMessage="😄 Social links saved" />
        )}

        {onErrorPage && <FailureAlert alertMessage="Oops, an error occured!" />}
      </div>
    </div>
  );
};

export default SocialInfo;
